import moment from 'moment-timezone';

const userTimeZone = App.globalContext.userTimeZone.name; //TODO Remove dependency on global timezone

const toUserTimeZone = dateTime => {
  return moment(new Date(dateTime))
    .tz(userTimeZone)
    .toDate();
};

export default { toUserTimeZone };
